module.exports = __webpack_public_path__ + "media/images/sp/stores/omiya/omiya_sns_05-4ba41c6c8c4349cd1f45e1a424058cef.jpg";